
import { Link } from 'react-router-dom';

const Footer = () => {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="bg-zinc-900 border-t border-zinc-800">
      <div className="max-w-7xl mx-auto px-6 lg:px-8 py-16">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-12">
          <div className="col-span-1 md:col-span-2">
            <img
              src="https://static.readdy.ai/image/0fc33fa68f46f743570ad8ba1c3172ea/a633ee2e637c32c0d1b1fde17290a4b0.png"
              alt="CruxOnAI"
              className="h-10 w-auto mb-6"
            />
            <p className="text-gray-400 text-sm leading-relaxed max-w-md">
              Precision AI systems engineered for service businesses. We identify operational friction and install intelligence exactly where it creates measurable leverage.
            </p>
          </div>

          <div>
            <h3 className="text-white font-semibold mb-4 text-sm uppercase tracking-wider">Company</h3>
            <ul className="space-y-3">
              <li>
                <Link to="/" className="text-gray-400 hover:text-emerald-400 transition-colors text-sm cursor-pointer">
                  Home
                </Link>
              </li>
              <li>
                <Link to="/approach" className="text-gray-400 hover:text-emerald-400 transition-colors text-sm cursor-pointer">
                  Approach
                </Link>
              </li>
              <li>
                <Link to="/industries" className="text-gray-400 hover:text-emerald-400 transition-colors text-sm cursor-pointer">
                  Industries
                </Link>
              </li>
            </ul>
          </div>

          <div>
            <h3 className="text-white font-semibold mb-4 text-sm uppercase tracking-wider">Contact</h3>
            <ul className="space-y-3">
              <li>
                <Link to="/contact" className="text-gray-400 hover:text-emerald-400 transition-colors text-sm cursor-pointer">
                  Schedule a Call
                </Link>
              </li>
              <li>
                <a href="mailto:contact@cruxonai.com" className="text-gray-400 hover:text-emerald-400 transition-colors text-sm cursor-pointer">
                  contact@cruxonai.com
                </a>
              </li>
            </ul>
          </div>
        </div>

        <div className="mt-12 pt-8 border-t border-zinc-800 flex flex-col md:flex-row justify-between items-center gap-4">
          <p className="text-gray-500 text-sm">
            © {currentYear} CruxOnAI. All rights reserved.
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
